import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { KeyValuePair } from '../models/common/keyValuePair';
import { CACHE_KEYS } from '../contants/CACHE_KEYS';
import { HttpClient } from '@angular/common/http';
import { LogService } from './log.service';
import { MessagesService } from './messages.service';
import { CommonService } from './common.service';
import { CacheService } from './cache.service';
import { environment } from '../../environments/environment';
import { of } from 'rxjs/observable/of';
import { tap, catchError } from 'rxjs/operators';

@Injectable()
export class ConfigurationService {

	private origin: string = environment.API_BASE_URL;

	constructor(
		private _http: HttpClient,
		private _logService: LogService,
		private _messagesService: MessagesService,
		private _common: CommonService,
		private _cacheService: CacheService
	) { }

	getEmployeeRoles(): Observable<KeyValuePair[]> {
		let value = this._cacheService.get(CACHE_KEYS.employeeRole)
		if (value != null) {
			return of(value);
		}

		return this._http.get<KeyValuePair[]>(`${this.origin}/api/configurations/roles`)
			.pipe(
				tap(x => {
					this.log('getEmployeeRoles');
					this._cacheService.add(CACHE_KEYS.employeeRole, x, 3600);
				}),
				catchError(this._logService.handleError<KeyValuePair[]>('getEmployeeRoles'))
			);
	}

	getPaymentTypes(): Observable<KeyValuePair[]> {
		let value = this._cacheService.get(CACHE_KEYS.paymentTypeSelection)
		if (value != null) {
			return of(value);
		}

		return this._http.get<KeyValuePair[]>(`${this.origin}/api/configurations/paymenttypes`)
			.pipe(
				tap(x => {
					this.log('getPaymentTypes');
					this._cacheService.add(CACHE_KEYS.paymentTypeSelection, x, 3600);
				}),
				catchError(this._logService.handleError<KeyValuePair[]>('getPaymentTypes'))
			);
	}

	getSalaryTypes(): Observable<KeyValuePair[]> {
		let value = this._cacheService.get(CACHE_KEYS.salaryTypeSelection)
		if (value != null) {
			return of(value);
		}

		return this._http.get<KeyValuePair[]>(`${this.origin}/api/configurations/salarytypes`)
			.pipe(
				tap(x => {
					this.log('getSalaryTypes');
					this._cacheService.add(CACHE_KEYS.salaryTypeSelection, x, 3600);
				}),
				catchError(this._logService.handleError<KeyValuePair[]>('getSalaryTypes'))
			);
    }
    
    getPayrollTypes(): Observable<KeyValuePair[]> {
		let value = this._cacheService.get(CACHE_KEYS.payrollTypeSelection)
		if (value != null) {
			return of(value);
		}

		return this._http.get<KeyValuePair[]>(`${this.origin}/api/configurations/payrolltypes`)
			.pipe(
				tap(x => {
					this.log('getPayrollTypes');
					this._cacheService.add(CACHE_KEYS.payrollTypeSelection, x, 3600);
				}),
				catchError(this._logService.handleError<KeyValuePair[]>('getPayrollTypes'))
			);
	}

	private log(message: string) {
		this._messagesService.add('ConfigurationService: ' + message);
	}
}



// WEBPACK FOOTER //
// ./src/app/services/configuration.service.ts